import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DeliveredToModel } from './deliveredTo.model';
import { environment } from '../../../../environments/environment';
import { catchError, map, Observable } from 'rxjs';

const API_URL = environment.apiUrl
@Injectable({
  providedIn: 'root'
})
export class DeliveredToService {

  constructor(private http: HttpClient) {}

  addDeliveredTo(deliveredto: DeliveredToModel) {
    
    return this.http.post(API_URL + '/DeliveredTo/CreateDeliveredTo', deliveredto, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  updateDeliveredTo(deliveredto: DeliveredToModel) {
    
    return this.http.put(API_URL + '/DeliveredTo/UpdateDeliveredTo', deliveredto, {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }

  getAllDeliveredTos(): Observable<DeliveredToModel[]> {
    return this.http.get(API_URL + '/DeliveredTo/ReadDeliveredTos', {
      withCredentials: true,
    }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }


  deleteDeliveredTo(deliveredto: DeliveredToModel) {
    
    return this.http.delete(API_URL + '/DeliveredTo/DeleteDeliveredTo',  {
      headers: {},
      body: deliveredto,
      withCredentials: true
   }).pipe(
      map((response: any) => {
        return response
      }),
      catchError((error: any) => {
        

        throw new HttpErrorResponse({
          status: error.error.statusCode,
          statusText: error.error.response,
        })
      }),
    )
  }


}
